const mapTimePeriod = {
  fifteenMinutes: "15",
  halfHourly: "30",
  hourly: "60",
  daily: "D",
  weekly: "W",
  monthly: "1M",
};

export default mapTimePeriod;
